
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/migration-support",
      function () {
        return require("private-next-pages/migration-support.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/migration-support"])
      });
    }
  